const MAX_RELOAD_ATTEMPTS = 3
const RELOAD_KEY = 'reload'
const RELOAD_TTL_MS = 60 * 1000 // 1 minute
/**
 * Since we have special cases where the browser ignores cache headers
 * then we need to trigger reload applivatively where its needed to perserve session functionality.
 * This is a solution for these cases untiil we decide to manipulate the DOM in the CDN edges instead
 * of using cookies for the client secret from the edge
 */
export function handleBrowserCache() {
	if (isBrowserCache()) {
		reload()
	}
}

function isBrowserCache() {
	// Only relevant in the browser
	if (typeof window !== 'undefined') {
		const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming
		const navType: NavigationTimingType = navEntry?.type || ''
		return navType === 'back_forward'
	}
	return false
}

/**
 * Reload the page if it's a back_forward navigation and
 * the reload counter is less than the maximum reload attempts
 */
function reload() {
	const { counter } = readReload()
	if (counter < MAX_RELOAD_ATTEMPTS) {
		persistReload(counter + 1)
		window.location.reload()
	} else {
		console.error('ATS: Max reload attempts reached')
	}
}
/**
 * Wrapped for access issues to prevent throwing exceptions without reason
 */
function wrappesSessionStorage(functionName: 'setItem' | 'getItem' | 'removeItem' | 'clear', data?: string) {
	try {
		return sessionStorage[functionName](RELOAD_KEY, data || '')
	} catch (error) {
		console.error('ATS: Error calling sessionStorage:', error)
	}
}

export function clearReload() {
	return wrappesSessionStorage('removeItem')
}

function persistReload(counter: number = 1) {
	return wrappesSessionStorage('setItem', `${Date.now()}-${counter}`)
}

function readReload() {
	const reloadState = wrappesSessionStorage('getItem')
	if (reloadState) {
		const [timestamp, count] = reloadState.split('-')
		const counter = count ? parseInt(count, 10) : 0

		// Reset counter if maxed out and TTL has expired
		if (counter >= MAX_RELOAD_ATTEMPTS) {
			const lastAttemptTime = timestamp ? Number(timestamp) : 0
			if (Date.now() - lastAttemptTime > RELOAD_TTL_MS) {
				return { counter: 0 }
			}
		}

		return { counter }
	}
	return { counter: 0 }
}
